import "./Reports.css";

const Reports = () => {
    return (
        <section className="dashboard-laris-acessorios">
            <div className="dashboard-content">
                <div className="Facility-Content-Page">
                    <div className="header">
                        <h1 className="title">Relatórios</h1>
                        <p className="subtitle">Exporte relatórios baseados em dados.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Reports;